import Users from "./Users";

export default Users;
